export default __webpack_public_path__ + "static/media/watch.6fb770fe.jpg";